module.exports = __webpack_public_path__ + "static/media/quicktip_info.86c492c5.svg";